import { ROUTES_NAMES, TRUE_TO_STRING } from '@/constants';
import { getCurrentUser, isAuthenticated, isExternalProvider, postMessageToParent, redirectToCallbackURL, setTokens } from '@/service/cognitoService';
import store from '@/store';
import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';

const beforeEnterRegistrationRoute = async (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext
): Promise<void> => {
  const clientId = to.query.client_id;
  const redirectURI = to.query.redirect_uri;

  if (!clientId || !redirectURI) {
    return next({ name: ROUTES_NAMES.error });
  }

  store.dispatch('setClientID', clientId);
  store.dispatch('setRedirectURI', redirectURI);

  const userIsAuthenticated = await isAuthenticated();
  if (userIsAuthenticated) {
    const { username, attributes } = await getCurrentUser();
    const isFirstLogin = attributes['custom:first_login'] === TRUE_TO_STRING;

    if (isExternalProvider(username) && isFirstLogin) {
      return next({ name: ROUTES_NAMES.federatedLogin });
    }

    await setTokens();
    store.getters.isIframe ? postMessageToParent(
      {
        idToken: store.getters.idToken,
        accessToken: store.getters.accessToken,
        refreshToken: store.getters.refreshToken
      }
    ) : redirectToCallbackURL();
    return next(false);
  }

  next();
};

export {
  beforeEnterRegistrationRoute
};
